import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Clock } from "lucide-react";
import Chat from "@/pages/Chat";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

function RetentionCard() {
  const [days, setDays] = useState("");
  const [saved, setSaved] = useState(0);
  useEffect(() => { api.get("/admin/settings").then(({ data }) => { setDays(String(data.chat_retention_days ?? 0)); setSaved(data.chat_retention_days ?? 0); }).catch(() => {}); }, []);
  const save = async () => {
    const n = parseInt(days, 10);
    if (Number.isNaN(n) || n < 0) return toast.error("Enter 0 or a positive number of days");
    try { const { data } = await api.put("/admin/settings", { chat_retention_days: n }); setSaved(data.chat_retention_days); toast.success(n ? `Messages older than ${n} days are purged nightly` : "Auto-delete off — messages are kept"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <div className="card-tactical rounded-md p-4 flex flex-wrap items-end gap-3" data-testid="chat-retention-card">
      <div className="flex-1 min-w-[220px]">
        <div className="text-[10px] tracking-widest uppercase opacity-60 inline-flex items-center gap-1"><Clock className="w-3 h-3" /> Auto-delete messages</div>
        <p className="text-xs opacity-70 mt-1">Permanently remove chat messages (and attachments) older than this many days. Runs nightly at 03:00 UK. Set 0 to keep everything.</p>
      </div>
      <div className="flex items-center gap-2">
        <Input type="number" min={0} max={3650} value={days} onChange={e => setDays(e.target.value)} className="w-24" data-testid="chat-retention-days" />
        <span className="text-xs opacity-60">days</span>
        <button type="button" onClick={save} className="btn-volt px-4 py-2 rounded-md text-xs tracking-widest uppercase" data-testid="chat-retention-save">Save</button>
      </div>
      <div className="w-full text-[11px] opacity-60" data-testid="chat-retention-status">{saved ? `Currently: delete after ${saved} days` : "Currently: keep forever"}</div>
    </div>
  );
}

export function ChatOversightTab() {
  return (
    <div className="space-y-4" data-testid="admin-chat-tab">
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#83B68B]">Safeguarding review</div>
        <h2 className="font-display font-black text-3xl mt-1">Chat oversight</h2>
        <p className="opacity-60 text-sm mt-1">Every conversation in the app — including private chats and user groups — for admins and Welfare Officers to review. You can read but not post in chats you're not a member of. Admins can delete any message.</p>
      </div>
      <RetentionCard />
      <Chat oversight />
    </div>
  );
}
